module.exports = __webpack_public_path__ + "static/media/upload.6d79f3cd.svg";